import * as moment from 'moment'

export class BillingTrialModel {
  subscriptionExempt: boolean
  status: 'trialActive' | 'trialExpired'
  monthsTrial: number
  trialEndsAt: moment.Moment

  /**
   * Constructor.
   *
   * @param data
   */
  constructor(data: { [key: string]: any }) {
    this.subscriptionExempt = data.subscriptionExempt || false
    this.status = data.status
    this.monthsTrial = data.monthsTrial
    this.trialEndsAt = moment(data.trialEndsAt)
  }
}



// WEBPACK FOOTER //
// ./src/app/main/models/billing/billing-trial-model.ts